import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery'
import { UsersService } from '../services/users.service';
import { Router } from '@angular/router';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  oldPasswordRequired:boolean = false ;oldPasswordError:boolean = false ;
  newPasswordRequired:boolean = false ;
  repeatPasswordRequired:boolean =false ; 
  repeatPasswordError:boolean = false ;

  constructor(private allUsers:UsersService , private router:Router)
   {
   
     if(this.allUsers.currentUser === 0)
     {
      this.router.navigateByUrl('/login');

     }

    }

  ngOnInit() {

    /****************jquery****************** */
    $(document).ready(function(){

      $(".fa-eye").click(function(){
        $(this).toggleClass('fa-eye-slash');
        if($(this).hasClass("fa-eye-slash"))
        {
          $(this).parent().prev().children( "input" ).attr('type',"text") ;
        }
        else
        {
          $(this).parent().prev().children( "input" ).attr('type',"password") ;
        }
      
      });

     


    });
  }
  checkPasswords()
  {
    var oldPassword = (<HTMLInputElement>document.getElementById("oldPassword")).value
    var newPassword = (<HTMLInputElement>document.getElementById("newPassword")).value 
    var repeatPassword = (<HTMLInputElement>document.getElementById("repeatPassword")).value 
    var currentUser = this.allUsers.currentUser ; 
    var oldCounter :number = 0 ;
    var y:number = 0 ;
   

    if(oldPassword === "")
    {
      this.oldPasswordRequired = true ; 
      this.oldPasswordError = false ; 
      y+= 1 
    }
    else 
    {
      for(let user of this.allUsers.users)
      {
  
        if(user.id === currentUser)
        {
          
          if(user.password !== oldPassword)
          { 
            this.oldPasswordRequired = false 
            this.oldPasswordError = true ;
            oldCounter += 1 
            y+=1
            break
          }
        }
      }
      if(oldCounter == 0)
      {
        this.oldPasswordError = false ; 
        this.oldPasswordRequired = false ; 
      }
    }
    
 

   if(newPassword === "")
   {
     this.newPasswordRequired = true ; 
     y+=1
   }
   else
   {
    this.newPasswordRequired = false 
   }

   if(repeatPassword === "")
   {
     this.repeatPasswordRequired = true ; 
     this.repeatPasswordError = false ; 
     y+=1
   }
   else if(newPassword !== repeatPassword)
   {
    this.repeatPasswordRequired = false ; 
    this.repeatPasswordError = true ;
    y+=1
   }
   else
   {
    this.repeatPasswordRequired = false ; 
    this.repeatPasswordError = false;
   }

   if(y>0)
   {
    document.getElementById("changePassword").classList.add('animated', 'bounce')
    setTimeout(function(){
      document.getElementById('changePassword').classList.remove('bounce')
    },1000) ; 
   }
   else
   {
     for(let  customer of this.allUsers.users)
     {
       if(this.allUsers.currentUser === customer.id)
       {
         customer.password = newPassword ;
         this.router.navigateByUrl('/login');
         break 
       }
     }
   }
  }

}
